export const NewEstateActionTypes = {
    NEW_ESTATE : 'NEW_ESTATE',
    EDIT_ESTATE_DETAILS:'EDIT_ESTATE_DETAILS'
}